import { render, staticRenderFns } from "./TransportTypeFromStsInput.vue?vue&type=template&id=7fc101a4&"
import script from "./TransportTypeFromStsInput.vue?vue&type=script&lang=js&"
export * from "./TransportTypeFromStsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports